<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('staff.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="staffInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="staffInfo.conditions.name" :placeholder="$t('staff.inputStaffName')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="staffInfo.conditions.tel" :placeholder="$t('staff.inputPhone')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="staffInfo.conditions.staffId" :placeholder="$t('staff.inputStaffId')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryStaffMethod">{{ $t('staff.query') }}</el-button>
            <el-button @click="_resetStaffMethod">{{ $t('staff.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('staff.staffManagement') }}</span>
        <el-button type="primary" size="small" class="float-right" @click="_openAddStaffStepPage">
          {{ $t('staff.add') }}
        </el-button>
      </div>

      <el-table :data="staffData" border style="width: 100%">
        <el-table-column prop="userId" :label="$t('staff.staffId')" align="center">
        </el-table-column>
        <el-table-column prop="name" :label="$t('staff.name')" align="center">
        </el-table-column>
        <el-table-column prop="tel" :label="$t('staff.phone')" align="center">
        </el-table-column>
        <el-table-column prop="orgName" :label="$t('staff.relatedOrg')" align="center">
        </el-table-column>
        <el-table-column prop="relCdName" :label="$t('staff.position')" align="center">
        </el-table-column>
        <el-table-column prop="email" :label="$t('staff.email')" align="center">
        </el-table-column>
        <el-table-column prop="address" :label="$t('staff.address')" align="center">
        </el-table-column>
        <el-table-column prop="sex" :label="$t('staff.gender')" align="center">
          <template slot-scope="scope">
            {{ scope.row.sex == 0 ? $t('staff.male') : $t('staff.female') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('staff.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditStaff(scope.row)">
              {{ $t('staff.edit') }}
            </el-button>
            <el-button size="mini" @click="_resetStaffPwd(scope.row)">
              {{ $t('staff.resetPassword') }}
            </el-button>
            <el-button v-if="scope.row.relCd != 600311000001" size="mini" type="danger"
              @click="openDeleteStaff(scope.row)">
              {{ $t('staff.delete') }}
            </el-button>
            <el-button size="mini" @click="openStaffDetail(scope.row)">
              {{ $t('staff.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="16">
          <div class="tip">
            {{ $t('staff.tip') }}
          </div>
        </el-col>
        <el-col :span="8">
          <el-pagination @current-change="currentPage" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>

    <reset-staff-pwd ref="resetStaffPwd"></reset-staff-pwd>
    <edit-staff ref="editStaff" @success="queryStaff"></edit-staff>
    <delete-staff ref="deleteStaff" @success="queryStaff"></delete-staff>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getStaffList, getOrgsByLevel } from '@/api/frame/staffApi'
import ResetStaffPwd from '@/components/frame/resetStaffPwd/resetStaffPwd'
import EditStaff from '@/components/frame/editStaff/editStaff'
import DeleteStaff from '@/components/frame/deleteStaff/deleteStaff'

export default {
  name: 'Staff',
  components: {
    ResetStaffPwd,
    EditStaff,
    DeleteStaff
  },
  data() {
    return {
      staffInfo: {
        moreCondition: false,
        branchOrgs: [],
        departmentOrgs: [],
        relCds: [],
        conditions: {
          branchOrgId: '',
          departmentOrgId: '',
          orgId: '',
          orgName: '',
          orgLevel: '2',
          parentOrgId: '',
          name: '',
          tel: '',
          staffId: '',
          parentOrgName: '',
          parentTwoOrgId: '',
          page: 1,
          rows: 10,
          row:10
        }
      },
      staffData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      try {
        const { data } = await getDict('u_org_staff_rel', 'rel_cd')
        this.staffInfo.relCds = data
        this.loadData(1, 10)
        this._getOrgsByOrgLevelStaff(1, 10, 2, '')
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    queryStaff(){
      this.loadData(1,this.pagination.pageSize)
    },
    async loadData(page, rows) {
      this.staffInfo.conditions.page = page
      this.staffInfo.conditions.rows = rows
      this.staffInfo.conditions.row = rows

      try {
        const res = await getStaffList(this.staffInfo.conditions)
        const staffList = res.data
        const relCdsList = this.staffInfo.relCds

        staffList.forEach((staff) => {
          relCdsList.forEach((rel) => {
            if (staff.relCd == rel.statusCd) {
              staff.relCdName = rel.name
            }
          })
        })

        this.staffData = staffList
        this.pagination.total = res.records
        this.pagination.currentPage = page
      } catch (error) {
        console.error('获取员工列表失败:', error)
      }
    },
    currentPage(currentPage) {
      this.loadData(currentPage, 10)
    },
    openEditStaff(staff) {
      this.$refs.editStaff.open(staff)
    },
    openDeleteStaff(staff) {
      this.$refs.deleteStaff.open(staff)
    },
    _moreCondition() {
      console.log(this.staffInfo.moreCondition)
      this.staffInfo.moreCondition = !this.staffInfo.moreCondition
    },
    async _getOrgsByOrgLevelStaff(page, rows, orgLevel, parentOrgId) {
      try {
        const res = await getOrgsByLevel({
          page,
          row: rows,
          orgLevel,
          parentOrgId
        })

        if (orgLevel == 2) {
          this.staffInfo.branchOrgs = res.orgs
        } else {
          this.staffInfo.departmentOrgs = res.orgs
        }
      } catch (error) {
        console.error('获取组织失败:', error)
      }
    },
    _openAddStaffStepPage() {
      this.$router.push('/pages/frame/addStaff')
    },
    _queryStaffMethod() {
      this.loadData(1, 10)
    },
    _resetStaffMethod() {
      this.staffInfo.conditions = {
        ...this.staffInfo.conditions,
        branchOrgId: "",
        orgId: "",
        departmentOrgId: "",
        name: "",
        tel: "",
        staffId: ""
      }
      this.loadData(1, 10)
    },
    _resetStaffPwd(staff) {
      this.$refs.resetStaffPwd.open(staff)
    },
    openStaffDetail(staff) {
      this.$router.push(`/pages/frame/staffDetail?staffId=${staff.userId}`)
    }
  },
  watch: {
    'staffInfo.conditions.branchOrgId': {
      handler(val) {
        this._getOrgsByOrgLevelStaff(1, 10, 3, val)
        this.staffInfo.conditions.parentOrgId = val
        this.staffInfo.conditions.departmentOrgId = ''
        this.loadData(1, 10)
      },
      deep: true
    },
    'staffInfo.conditions.departmentOrgId': {
      handler(val) {
        this.staffInfo.conditions.orgId = val
        this.loadData(1, 10)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.tip {
  color: #999;
  font-size: 12px;
  line-height: 30px;
}

.float-right {
  float: right;
}
</style>